/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */

/* Project Import will be here */
import SecurityComponent from './security.Component';

import { bindActionCreators } from 'redux';
import * as actions from '../../actions/login.Action';

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class Security extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSecurityClicked: true     
        };
    }

    onClickSecurity(){
        this.setState({
            isSecurityClicked: true 
        });
    }

    render() {
        const { isSecurityClicked } = this.state;
        return (
            <Fragment>
                <SecurityComponent
                    {...{
                        security: {
                            isSecurityClicked
                        }
                    }}
                    user={this.props.user}
                    onClickSecurity={this.onClickSecurity.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
      Object.assign({},
        actions),
      dispatch);
  }

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Security));

Security.displayName = 'Security';